import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { isPresent } from '../helpers/string_helpers';

import './styles/empty_notice.scss';

export default class EmptyNotice extends React.Component {
  static propTypes = {
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  };

  render() {
    return (
      <div className="empty-notice">
        {this.renderIcon()}
        {this.renderTitle()}
        {this.renderSubtitle()}
      </div>
    );
  }

  renderIcon() {
    const { icon } = this.props;

    if (isPresent(icon)) {
      return <FontAwesomeIcon icon={icon} size={"6x"} />;
    }
  }

  renderTitle() {
    const { title } = this.props;

    if (isPresent(title)) {
      return (
        <h2 className="text-muted">
          <strong>{title}</strong>
        </h2>
      );
    }
  }

  renderSubtitle() {
    const { subtitle } = this.props;

    if (isPresent(subtitle)) {
      return (
        <h3 className="text-muted text-center">
          {subtitle}
        </h3>
      );
    }
  }
}
